import { Icon } from '@/components/common';
import { SUPPORT_EMAIL } from '@/constants/common';
import { Button } from '../../buttons';
import styles from './AgeWarning.module.css';

interface AgeWarningProps {
  onClickNext: () => void;
}

export const AgeWarning = ({ onClickNext }: AgeWarningProps) => {
  return (
    <div className={styles.container}>
      <Icon name="infoCircled" className={styles.icon} size={40} />
      <h3 className={styles.title}>Attention!</h3>

      <p className={styles.description}>
        Thank you for selecting RelayPay for all your cryptocurrency needs. To ensure your experience with RelayPay is
        the best it can be, we have put your safety as our number one priority. We understand that cryptocurrency may be
        a new and unfamiliar concept to you, so we urge you to exercise caution when using our platform.
      </p>

      <p className={styles.description}>
        Cryptocurrency is a digital form of currency that is decentralized and operates independently of banks and
        governments. This means that it is not backed by any physical asset or entity, and its value can be highly
        volatile. Cryptocurrency transactions are irreversible, which means that if you send funds to an incorrect
        address, those funds may be irretrievable. We urge you to take extra care when sending cryptocurrency
        transactions and ensure that you double-check the recipient’s address before sending any funds. It is also
        essential to keep your account information safe and secure and never share your passwords with anyone.
      </p>

      <p className={styles.description}>
        Please keep in mind that while cryptocurrency can be a powerful tool, it is also complex and comes with risks.
        If you are unsure about anything related to cryptocurrency or RelayPay, we strongly recommend seeking advice
        from a financial professional before using our platform.Thank you for choosing RelayPay, and please don’t
        hesitate to reach out to{' '}
        <a className={styles.link} href={SUPPORT_EMAIL}>
          support@relaypay.io
        </a>
      </p>

      <Button className={styles.button} onPress={() => onClickNext()}>
        Next
      </Button>
    </div>
  );
};
